import { z } from "zod";
import { isValidDate, isGreaterThanDate } from "../../../../../../../../../../../utils/dateValidate";

export const schema = z.object({
    setor: z.string().min(1, { message: "Setor é obrigatório" }),
    unidade: z.string().min(1, { message: "Unidade é obrigatório" }),
    data_inicio: z.string().min(10, { message: "Data de início é obrigatória" }),
    data_fim: z.string().min(10, { message: "Data de fim é obrigatória" }),
    ignorar_feriados: z.boolean().default(false),
    sabado: z.boolean().default(false),
    domingo: z.boolean().default(false),
}).superRefine((data, ctx) => {
    if (!isValidDate(data.data_inicio)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Data início inválida",
            path: ["data_inicio"],
        });
    }

    if (!isValidDate(data.data_fim)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Data fim inválida",
            path: ["data_fim"],
        });
    }

    if (!isGreaterThanDate(
        data.data_fim.split("/").reverse().join("-"),
        data.data_inicio.split("/").reverse().join("-")
    )) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Data fim deve ser maior que a data início",
            path: ["data_fim"],
        });
    }
})
